import { render, staticRenderFns } from "./worklist_item.vue?vue&type=template&id=294e995d&scoped=true"
import script from "./worklist_item.vue?vue&type=script&lang=js"
export * from "./worklist_item.vue?vue&type=script&lang=js"
import style0 from "./worklist_item.vue?vue&type=style&index=0&id=294e995d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294e995d",
  null
  
)

export default component.exports